import { ELEMENT_TAG_COLORS, ELEMENT_TAG_DEFAULT_COLOR } from '../lib/subPanelLabels';

// 02.3-client.md paso b -- extraído del bloque `activeSubTab === 'outside-ins'` de
// SubPanelTratos.jsx (selector de vista tabla/JSON + las 2 tablas "datos actuales"/"datos
// recibidos" + el visor JSON). Presentacional: sin `clientApi`/hooks/toast -- toda la data
// (`currentItems`/`receivedItems`/`consolidatedJson`, ya memoizados en el container) y los
// `on*` vienen por props. Estilos inline preservados verbatim (conversión a tokens es el
// paso `e`).

function ElementBadge({ element }) {
    const { bg, fg } = ELEMENT_TAG_COLORS[element] || ELEMENT_TAG_DEFAULT_COLOR;
    return (
        <span style={{ background: bg, color: fg, padding: '2px var(--space-2)', borderRadius: 'var(--radius-sm)', fontSize: '9px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.3px', display: 'inline-block' }}>
            {element}
        </span>
    );
}

function ItemsTable({ title, dotColor, items, emptyLabel }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
            <div style={{ fontSize: '12px', fontWeight: '600', color: dotColor, textTransform: 'uppercase', letterSpacing: '0.5px', display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
                <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: dotColor }}></div>
                {title}
            </div>

            {items.length === 0 ? (
                <div style={{ padding: 'var(--space-4)', background: 'rgba(255,255,255,0.01)', border: '1px dashed rgba(255,255,255,0.06)', borderRadius: 'var(--radius-md)', color: 'rgba(255,255,255,0.3)', fontSize: '11px', textAlign: 'center', fontStyle: 'italic' }}>
                    {emptyLabel}
                </div>
            ) : (
                <div style={{ overflowX: 'auto', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 'var(--radius-md)', background: 'rgba(255,255,255,0.01)' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px', textAlign: 'left' }}>
                        <thead>
                            <tr style={{ background: 'rgba(255,255,255,0.03)', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                                <th style={{ padding: 'var(--space-3) var(--space-3)', fontWeight: '600', color: 'rgba(255,255,255,0.6)' }}>CAMPO</th>
                                <th style={{ padding: 'var(--space-3) var(--space-3)', fontWeight: '600', color: 'rgba(255,255,255,0.6)' }}>DATO</th>
                                <th style={{ padding: 'var(--space-3) var(--space-3)', fontWeight: '600', color: 'rgba(255,255,255,0.6)', width: '90px' }}>ELEMENT</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((item, idx) => (
                                <tr key={idx} style={{ borderBottom: '1px solid rgba(255,255,255,0.04)', background: idx % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.005)' }}>
                                    <td style={{ padding: 'var(--space-3) var(--space-3)', color: '#fff', fontWeight: '500' }}>{item.campo}</td>
                                    <td style={{ padding: 'var(--space-3) var(--space-3)', color: 'rgba(255,255,255,0.85)', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {item.isLink ? (
                                            <a href={item.dato} target="_blank" rel="noopener noreferrer" style={{ color: '#10b981', display: 'flex', alignItems: 'center', gap: 'var(--space-1)', textDecoration: 'underline' }}>
                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
                                                Ver archivo
                                            </a>
                                        ) : item.dato}
                                    </td>
                                    <td style={{ padding: 'var(--space-3) var(--space-3)' }}><ElementBadge element={item.element} /></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default function SubPanelOutsideIns({ viewMode, onChangeViewMode, currentItems, receivedItems, consolidatedJson, copiedJson, onCopyJson }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-5)', padding: 'var(--space-1) 0' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'rgba(255,255,255,0.02)', padding: 'var(--space-3) var(--space-4)', borderRadius: 'var(--radius-md)', border: '1px solid rgba(255,255,255,0.04)' }}>
                <span style={{ fontSize: '11px', fontWeight: '700', color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Vista</span>
                <div style={{ display: 'flex', background: 'rgba(0,0,0,0.2)', padding: '2px', borderRadius: 'var(--radius-sm)', border: '1px solid rgba(255,255,255,0.06)' }}>
                    <button
                        type="button"
                        onClick={() => onChangeViewMode('table')}
                        style={{ background: viewMode === 'table' ? '#f97316' : 'transparent', border: 'none', color: '#fff', fontSize: '11px', fontWeight: '600', padding: 'var(--space-2) var(--space-4)', borderRadius: 'var(--radius-sm)', cursor: 'pointer', outline: 'none', transition: 'all 0.2s', boxShadow: viewMode === 'table' ? '0 2px 4px rgba(0,0,0,0.2)' : 'none' }}
                    >
                        Tabla
                    </button>
                    <button
                        type="button"
                        onClick={() => onChangeViewMode('json')}
                        style={{ background: viewMode === 'json' ? '#f97316' : 'transparent', border: 'none', color: '#fff', fontSize: '11px', fontWeight: '600', padding: 'var(--space-2) var(--space-4)', borderRadius: 'var(--radius-sm)', cursor: 'pointer', outline: 'none', transition: 'all 0.2s', boxShadow: viewMode === 'json' ? '0 2px 4px rgba(0,0,0,0.2)' : 'none' }}
                    >
                        JSON
                    </button>
                </div>
            </div>

            {viewMode === 'table' ? (
                <>
                    <ItemsTable title="Datos actuales del elemento" dotColor="#f97316" items={currentItems} emptyLabel="No hay datos registrados en este elemento." />
                    <div style={{ marginTop: 'var(--space-3)' }}>
                        <ItemsTable title="Datos recibidos" dotColor="#3b82f6" items={receivedItems} emptyLabel="No se han recibido datos de otros elementos conectados." />
                    </div>
                </>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)', position: 'relative' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.4)', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Payload de nexo</span>
                        <button
                            type="button"
                            onClick={onCopyJson}
                            style={{ background: copiedJson ? '#10b981' : 'rgba(255,255,255,0.05)', border: 'none', color: '#fff', fontSize: '10px', fontWeight: '600', padding: 'var(--space-1) var(--space-3)', borderRadius: 'var(--radius-sm)', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 'var(--space-1)', transition: 'all 0.2s' }}
                        >
                            {copiedJson ? (
                                <>
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                    ¡Copiado!
                                </>
                            ) : (
                                <>
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
                                    Copiar JSON
                                </>
                            )}
                        </button>
                    </div>

                    <textarea
                        readOnly
                        aria-label="Payload de nexo (JSON)"
                        value={JSON.stringify(consolidatedJson, null, 2)}
                        style={{ width: '100%', height: '350px', fontFamily: 'SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace', fontSize: '11px', background: 'rgba(0,0,0,0.25)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 'var(--radius-md)', color: '#a7f3d0', padding: 'var(--space-3)', resize: 'none', lineHeight: '1.5', outline: 'none' }}
                    />
                </div>
            )}
        </div>
    );
}
